import { useTranslation } from 'react-i18next';
import { Flex, Select, Typography } from 'antd';
import { useTripTaskStore } from 'shared/stores';
import { CargoType } from 'types/cargo';
import type { ETripTaskType } from 'types/trips';
import { RETURN_ASSET_TASK_TYPE_OPTION, TASK_TYPE_OPTIONS } from './constants';

export const TaskType = () => {
  const { t } = useTranslation('trip');
  const { taskType, setTaskType, cargoTrips } = useTripTaskStore();
  const canReturnAsset = cargoTrips.length === 1 && cargoTrips[0].cargo.type === CargoType.CONTAINER;
  const taskTypeOptions = canReturnAsset ? [...TASK_TYPE_OPTIONS, RETURN_ASSET_TASK_TYPE_OPTION] : TASK_TYPE_OPTIONS;

  const handleChange = (value: ETripTaskType) => {
    setTaskType(value);
  };

  return (
    <Flex gap='large' vertical>
      <Typography.Text type='secondary'>{t('create_tasks_step_task_type_helper')}</Typography.Text>
      <Select
        size='large'
        placeholder={t('select_task_type')}
        value={taskType}
        options={taskTypeOptions}
        onChange={handleChange}
      />
    </Flex>
  );
};
